import React, { useCallback, useContext, useEffect, useReducer, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Card, Col, Image, message, Modal, Row, Slider, Spin, Tabs } from "antd";
import { inElectron, storage } from "@/util";
import { initialState, reducer } from '@/Action';
import { LOGININFOSTORE, LOGINTOKEN, METTINGPAGE_SAVED_MEETING_INFO, RECORD_SERVER } from "@/config/const";
import { Commond, ConferenceInterface, RoleCode } from "@/types";
import { checkPlayTips } from "@/api/conference";
import debounce from 'lodash/debounce';
import { PhoneOutlined, UserAddOutlined, } from "@ant-design/icons";
import { eventEmitter } from "@/hooks/use-rtc"
import Icon from "@/component/Icon";
import {
  CloseSquareIcon,
  MediaIcon,
  type MicrophoneIconRef,
  ShareIcon,
  SoundIcon,
  VideoIcon,
} from "@/component/ToggleIcon";
import RoomClient from "../../../qrtc_web_sdk/RoomClient100";
import Btn from "./Btn";
import { MeetingContext } from "@/pages/Meeting";
import style from "./style.module.scss";
import Cmenu from "@/component/Menu";
import useDevices from "@/hooks/use-device";
import { closeStream, selectSource } from "@/util/electronShare";
import * as _ from "lodash";
import useWindowSize from "@/hooks/use-window";
import useQuery from "@/hooks/use-query";
import { conference } from "@/api";
import { useAuth } from "@/component/Auth";
import { QRTCMediaDeviceChangeEvent } from "@/qrtc_web_sdk/RoomParams";
import SpeakerTest from "./Modal/speaker";
import MicrophoneTest from "./Modal/microphone";
import { useMqtt } from "@/hooks/use-mqtt";
import ee from "@/util/event";

const { TabPane } = Tabs;
const { Meta } = Card;

const electron = (window as any).electron;

interface PropType {
  showParticipants: () => void;
  open: (v: string) => void;
}

interface MeetingControlPayload {
  peerId?: string;
  operatorPeerId?: string;
}
let roomClient: RoomClient;

let lastAudioStatus: boolean;

const Footer = (props: PropType) => {
  const [showApplyTobeHostButton, setShowApplyTobeHostButton] = useState(false);

  const { showParticipants, open } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const { participants, displayParticipants, service } = useContext(MeetingContext);
  const { winWidth, winHeight } = useWindowSize();
  const [isAiActive, setIsAiActive] = useState(false); // 状态变量来跟踪AI是否已启动  
  const [isAiLoading, setIsAiLoading] = useState(false);
  const [isMcuActive, setIsMcuActive] = useState(false); // 状态变量来跟踪MCU是否已启动

  const { speaker: querySpeaker } = useQuery();

  const history = useHistory();

  const { publish } = useMqtt()

  const [videos, setVideos] = React.useState([]);
const [isLeaveModalVisible, setIsLeaveModalVisible] = React.useState(false);
  const [modelShow, setModelShow] = React.useState(false);
  const [sourceList, setSourceList] = React.useState([]);
  const [selectedSource, setSelectedSource] = React.useState({});
  const [streamSrc, setStreamSrc] = React.useState({});
  const [isSpining,setIsSpining]=React.useState(false);
  const videoRef = useRef(null);

  const [audios, setAudios] = React.useState([]);
  const [mics, setMics] = React.useState([]);

  const [videoSelect, setVideoSelect] = React.useState("");
  const [audioSelect, setAudioSelect] = React.useState("");
  const [micSelect, setMicSelect] = React.useState("");
  const [sharing, setSharing] = React.useState(false);
  const [isRecording, setIsRecording] = React.useState(participants[0].recording);
  // const { dispatch } = useContext(StateContext);

  const auth = useAuth();
  const { loggedIn, loginfo, updateLogInfo } = auth;
  //是否正在录制
  //const isRecordingRef = useRef(false);

  let { conference: conf } = useContext(MeetingContext);
  
  const [inputs, setInputs] = React.useState([]);
  const [outputs, setOutputs] = React.useState([]);
  const [current, setCurrent] = React.useState("default");

  const userInfo = storage.get(LOGININFOSTORE);
  const [conferenceInfo, setConferenceInfo] = React.useState<ConferenceInterface>()

  const { setCallback, unSubscribe } = useMqtt()

  const checkDevice = async () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { videos, mics, audios } = await useDevices();

    if (videos.length) setVideoSelect(videos[0].deviceId);
    setVideos(videos);

    if (mics.length) setMicSelect(mics[0].deviceId);
    setMics(mics);

    if (audios.length) setAudioSelect(audios[0].deviceId);
    setAudios(audios);

    const devices = await navigator.mediaDevices.enumerateDevices();
    const inputsDevices = devices.filter(
      (device) => device.kind === "audioinput"
    );
    const outputsDevices = devices.filter(
      (device) => device.kind === "audiooutput"
    );
    setInputs(inputsDevices);
    setOutputs(outputsDevices);
  };

  React.useEffect(() => {
     me.audio = true
    checkDevice();
  }, []);
  React.useEffect(() => {
    const handleHostLeaveMeeting = () => {
      setShowApplyTobeHostButton(true);
    };

    eventEmitter.on('hostLeaveMeeting', handleHostLeaveMeeting);

    // 在组件卸载时移除事件监听器
    return () => {
      eventEmitter.off('hostLeaveMeeting', handleHostLeaveMeeting);
    };
  }, []);
  const choiceDevice = async (type: string, id: string) => {
    if (type === "mic") {
      setMicSelect(id);
      await service.setCurrentMic(id);
    } else if (type === "audio") {
      setAudioSelect(id);
      await service.setCurrentSpeaker(id);
      // service.setAudioPlayoutVolume(100);
    } else {
      setVideoSelect(id);
      await service.setCurrentCameraDevice(id);
    }
  };

  const micsItems = React.useMemo(() => {
    return mics.map((x) => ({
      k: x.deviceId,
      v: x.label || x.deviceId,
    }));
  }, [mics]);

  const [isTestMicrophone, setIsTestMicrophone] = React.useState(false);

  const micsMenu = React.useMemo(() => {
    return (
      <Cmenu
        items={micsItems}
        selectedItems={[micSelect]}
        onSelect={(v) => choiceDevice("mic", v)}
        clickItem={{v: '测试麦克风', cb : () =>  setIsTestMicrophone(true) }}
        title="请选择麦克风"
        single
      />
    );
  }, [micSelect, micsItems]);

  const audioItems = React.useMemo(() => {
    return audios.map((x) => ({
      k: x.deviceId,
      v: x.label || x.deviceId,
    }));
  }, [audios]);

  const audiosMenu = React.useMemo(() => {
    return (
      <Cmenu
        items={audioItems}
        selectedItems={[audioSelect]}
        onSelect={(v) => choiceDevice("audio", v)}
        title="请选择扬声器"
        single
      />
    );
  }, [audioItems, audioSelect]);

  const videoItems = videos.map((x) => ({
    k: x.deviceId,
    v: x.label || x.deviceId,
  }));

  const videoMenu = (
    <Cmenu
      items={videoItems}
      selectedItems={[videoSelect]}
      onSelect={(v) => choiceDevice("video", v)}
      title="请选择视频设备"
      single
    />
  );

  const [volume, setVolume] = useState(100);
  const [lastVolume, setLastVolume] = useState(volume);

  const volumeControl = () => {
    return (
      <div>
        <Slider
          vertical
          defaultValue={volume}
          value={volume}
          style={{ height: "100px"}}
          onChange={(value: number) => {
            setSoundMute(value === 0);
            setVolume(value);
            service.setAudioPlayoutVolume(value);
          }}
        />
      </div>
    )
  };
  
  const [soundMute,setSoundMute] = useState(false);

  const handleSound = () => {
    setLastVolume(volume === 0 ? 50 : volume);
    service.setAudioPlayoutVolume(!soundMute ? 0 : lastVolume);
    setVolume(!soundMute ? 0 : lastVolume);


    if (!soundMute) {
      service.muteAllRemoteAudios();
    } else {
      service.unMuteAllRemoteAudios();
    }

    setSoundMute(!soundMute);
  }

  const shareItem = [
    { k: "screen", v: "屏幕共享", c: true },
    // { k: "board", v: "白板共享", c: true },
  ];

  const sliveItem = [
    { k: "copy", v: "复制网址", c: true },
    { k: "open", v: "打开直播界面", c: true },
  ];

  const selectShare = (v: string) => {
    const share = participants.find((d) => d.share);
    if (share) {
      message.error('其他用户正在共享，暂时无法进行共享操作');
      return
    }

    if (v === "screen"){
      if (inElectron()){
        showShareModal();
      }else{
        service.openShare();
      }     
    } 
    open(v);
  };

  const CopyUrl = (v: string) => {
    
    if (v === "copy"){
      if (inElectron()){
        showShareModal();
      }else{
        navigator.clipboard.writeText(`http://${window.location.hostname}:8011/#/live/${conf.conferenceNo}`)
        .then(() => {
          message.success("复制成功");
        })
        .catch(err => {
          message.error("Copy Failed");
        });
      }     
    } else if (v === "open") {
      window.open(`http://${window.location.hostname}:8011/#/live/${conf.conferenceNo}`, '_blank');
    }
    open(v);
  };

  const shareMenu = (
    <Cmenu items={shareItem} selectedItems={[]} onSelect={selectShare} />
  );

  const livestream = (
    <Cmenu items={sliveItem} selectedItems={[]} onSelect={CopyUrl} />
  );

  const [isTestSpeaker, setIsTestSpeaker] = useState(false);

  const testSpeaker = () => { 
    const items = [{ k: "link", v: "测试扬声器", c: true }];
    
    const click = () => {
      setIsTestSpeaker(true)
    };

    return (<Cmenu items={items} selectedItems={[]} onSelect={click} />);
  }

  const recordMenu = () => { 
    const items = [{ k: "link", v: "我的录制", c: true }];
    const accessToken = storage.get(LOGINTOKEN);
    const username = auth.loginfo.username;
    
    const selectRecord = () => {
      const url = `${RECORD_SERVER}#/autologin/username=${username}/token=${accessToken}`;
      window.open(url);
    };

    return (<Cmenu items={items} selectedItems={[]} onSelect={selectRecord} />);
  }

  const showLeaveModal = () => {
    setIsLeaveModalVisible(true);
  };

  const handleOk = async () => {
       // 确认按钮的处理逻辑
    setIsLeaveModalVisible(false);

    const conf: ConferenceInterface = storage.get(
      METTINGPAGE_SAVED_MEETING_INFO
    );

    console.log("[Footer] leave conf:", conf);

    const params={
      roomId:conf.roomId,
      conferenceNo: conf.conferenceNo,
      peerId:me.peerId,
      conferenceToken:conf["X-Conference-Token"],
    }
    console.log(`[Footer] leave params:`, params);
    
    
    console.log("leaveConference params:::::",params )
    conference.leaveConference(params.roomId, params.peerId, params.conferenceToken, params.conferenceNo).then((resyueye)=>{
      console.log("entering leaveConference ",resyueye)
       
      var currParticipant = state.CurrParticipant;
      // currParticipant=storage.get(consts.CurrParticipant);
      console.log("leaveConference:::::",currParticipant.roleCode)
      console.log("roleCode:::::",me.roleCode)
      //roomClient = new RoomClient();
      if(me.roleCode===RoleCode.host ){
        // participants.filter(participant => participant.peerId !== params.peerId);
        const index = participants.findIndex(participant => participant.peerId === params.peerId);

      if (index !== -1) {
        participants.splice(index, 1);
      }

        console.log("host leave !!!!!!!!!!!:::::",me.roleCode)
        // hostLeaveMeeting();
        //roomClient.sendHostLeaveMsg(10, "host leave");
        
        // roomClient.sendCustomCmdMsg(10, "host leave");
      } else {
        //   
        // roomClient.sendHostLeaveMsg(11, "host not leave");
        console.log("host not leave" )
      }
     
      const getMeetings = async () => {
        const params = {
          pageNum: 0,
          pageSize: 100,
          param: {},
        };
        const ret = await conference.orderList(params);
        console.log(ret)
          
        // dispatch({type:"SetMeetingRecords", ret})
          
      };
      console.log(resyueye);
      const conferenceNo = storage.get("thisisakeyforsavemeetinginfo").conferenceNo;
      //如果是预约会议，检查当前时间是否已经超过了预约的结束时间
      
      //check if no persion in room first
      // 只有点了结束会议，才能结束，否则会议是不会结束的
      // conference.countOngoingUserAmt( conferenceNo,params.roomId).then((res)=>{
      //   console.log("entering countOngoingUserAmt")
      //   console.log("countOngoingUserAmt"+res);
      //   if (!resyueye.data && res && !res.data    ){        
      //     conference.updateEndTime(conferenceNo,params.roomId).then((resx)=>{
      //       conference.forceEnd(params.roomId).then((res)=>{
      //         console.log("MoveOngoingToHistoryConference:::",res);
      //         // orderList
      //         getMeetings()
      //           service.close();
      //           console.log(" history回退")
      //           history.replace("/");    
      //       })
      //     })
          
      //   } else {
      //     console.log("still have user in room:",res.data);
         
      //     console.log("没到结束时间:",resyueye.data);
      //   }
      // })
       
  });
    await service.close();
    unSubscribe()
    console.log("history回退上一页")
    // await history.goBack();
    history.replace("/");
  };

  const handleCancel = () => {
    // 取消按钮的处理逻辑
    setIsLeaveModalVisible(false);
  };

  //异步函数

  const handleEndMeeting = async () => {
    // 结束会议按钮的处理逻辑
    setIsLeaveModalVisible(false);
    //第一步发送 结束会议的 会控指令
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    //先发送结束录制指令
    if(isRecording){
    await conference.conferenceControl(
      {
        command: Commond.stopRecord,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer,

      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
    }
    await conference.conferenceControl(
      {
        command: Commond.endConference,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
    //第二步调用sdk的leave方法
    await service.exitRoom(true);
    unSubscribe()
    //第三步跳转到首页
    history.replace("/");
  };

  


  const me = participants[0];
  const meRef = useRef(me);
  const participantsRef = useRef(participants);
  const confRef = useRef(conf);

  useEffect(() => {
    meRef.current = me;
  }, [me]);

  useEffect(() => {
    participantsRef.current = participants;
  }, [participants]);

  useEffect(() => {
    confRef.current = conf;
  }, [conf]);

  const canHandleControl = useCallback((payload?: MeetingControlPayload) => {
    const operatorPeerId = payload?.operatorPeerId;
    if (!operatorPeerId) return false;

    const curConf = confRef.current;
    const ownerPeerId = `${curConf.roomId}_${curConf.ownerId}`;
    if (operatorPeerId === ownerPeerId) return true;

    const onlinePeer = participantsRef.current.find((p) => p.peerId === operatorPeerId);
    const offlinePeer = (curConf.attendList || []).find((p) => p.peerId === operatorPeerId);
    const roleCode = (onlinePeer || offlinePeer)?.roleCode;

    return roleCode === RoleCode.host || roleCode === RoleCode.cohost;
  }, []);
// 带宽先做， 场景突变 
const leave = useCallback(debounce(() => {
  // 你的代码
  console.log("entering leave method")
  showLeaveModal();
}, 1000), []);
  

  const [speaker, setSpeaker] = React.useState(querySpeaker === "true");

  const speakerClick = () => {
    service.setAudioPlayoutVolume(speaker ? 0 : 100);
    setSpeaker(!speaker);
  };

  const getInputSources = async (func: any) => {
    if (inElectron()) {
      let res = await electron.showSharewWin();
      let resGp = _.toPairsIn(_.groupBy(res, (item) => item.id.substr(0, 6)));
      setSourceList(resGp);
      func();
    }
  };

  const showShareModal = () => {
      setIsSpining(true);
      getInputSources(() => {
      setIsSpining(false);
      setModelShow(true);
    });
  };

  const hideShareModal = () => {
    setModelShow(false);
  };

  const shareCapture = async () => {
    let streamSrc = await selectSource(selectedSource);
    service.openElectronShare(streamSrc);
    setStreamSrc(streamSrc);
    setSharing(true);
    setModelShow(false);
  };

  const closeShareCapture = async () => {
    closeStream(streamSrc);
    service.closeElectronShare();
    setSharing(false);
  };
//<Btn icon={<ShareIcon active={true} />} onClick={showShareModal}>
  const sharingBtn = () => {
    if (inElectron()) {
      if (sharing) {
        return (
          <Btn
            icon={<CloseSquareIcon active={false} />}
            onClick={closeShareCapture}
          >
            {" "}
            关闭共享
          </Btn>
        );
      } else {
        return (
          <Btn icon={<ShareIcon active={true} />} dropdown={shareMenu}>
            {" "}
            共享
          </Btn>
        );
      }
    } else {
      return (
        <Btn icon={<ShareIcon active={true} />} dropdown={shareMenu}>
          共享
        </Btn>
      );
    }
  };

  const selSource = (e: any, source: any) => {
    setSelectedSource(source);
  };

  function getConference() {
    setTimeout(async () => {
      const res = await checkPlayTips(conf.conferenceNo) as ConferenceInterface
      setConferenceInfo(res)
      // storage.save(METTINGPAGE_SAVED_MEETING_INFO, res);
      setIsRecording(res.recordPermission === 3)
    }, 500)
  }

  const serverRecording = conferenceInfo?.recordPermission === 3;
  const recordingActive = Boolean(isRecording || serverRecording);

  useEffect(() => {
    getConference()
    setCallback(Commond.startRecord, getConference)
    setCallback(Commond.stopRecord, getConference)
  }, []);

  const startRecording = () => {
    if (recordingActive) {
      message.warning("当前会议已在录制中");
      return
    }
    //service.setRemoteVideoStreamType(participants[1].peerId, 1);
    //return;
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };

    const recordPayload = {
      command: Commond.startRecord,
      metadata: "",
      seq: "",
      room: conf.roomId,
      from: fromPeer,
      "X-Conference-No": conf.conferenceNo,
      "X-Channel-Token": conf["X-Channel-Token"],
      "X-Conference-Token": conf["X-Conference-Token"],
    };

    publish({
      command: Commond.startRecord,
      data: recordPayload,
    }, 'meeting')
    console.log("[record] publish mqtt startRecord", {
      roomId: conf.roomId,
      conferenceNo: conf.conferenceNo,
      isRecording,
      serverRecording,
      recordPayload,
    });
    setIsRecording(true);

    // conference.conferenceControlWithPromise(
    //   {
    //     command: Commond.startRecord,
    //     metadata: "",
    //     seq: "",
    //     room: conf.roomId,
    //     from: fromPeer
    //   },
    //   {
    //     "X-Conference-No": conf.conferenceNo,
    //     "X-Channel-Token": conf["X-Channel-Token"],
    //     "X-Conference-Token": conf["X-Conference-Token"],
    //   }
    // )
    // .then(response => {
    //   // 成功处理
    //   setIsRecording(true);
    // })
    // .catch(error => {
    //   console.log("录制启动失败: " + error.message);
    //   // 失败处理，界面提示
    //   message.error("录制启动失败: " + error.message);
    //   //alert("录制启动失败: " + error.message);
    // });
  };

  const stopRecording = () => {
    if (!recordingActive) {
      message.warning("当前会议未在录制中");
      return;
    }

    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };

    const recordPayload = {
      command: Commond.stopRecord,
      metadata: "",
      seq: "",
      room: conf.roomId,
      from: fromPeer,
      "X-Conference-No": conf.conferenceNo,
      "X-Channel-Token": conf["X-Channel-Token"],
      "X-Conference-Token": conf["X-Conference-Token"],
    };
    // record.recordComplete({
    //     peerId: me.peerId,
    //     roomId: conf.roomId,
    // }).then((res) => {
    //   console.log("recordComplete", res);
    // });

    publish({
      command: Commond.stopRecord,
      data: recordPayload,
    }, 'meeting')
    console.log("[record] publish mqtt stopRecord", {
      roomId: conf.roomId,
      conferenceNo: conf.conferenceNo,
      isRecording,
      serverRecording,
      recordPayload,
    });
    setIsRecording(false);

    // conference.conferenceControlWithPromise(
    //   {
    //     command: Commond.stopRecord,
    //     metadata: "",
    //     seq: "",
    //     room: conf.roomId,
    //     from: fromPeer,
    //   },
    //   {
    //     "X-Conference-No": conf.conferenceNo,
    //     "X-Channel-Token": conf["X-Channel-Token"],
    //     "X-Conference-Token": conf["X-Conference-Token"],
    //   }
    // )
    // .then(response => {
    //   // 成功处理
    //   setIsRecording(false);
    // })
    // .catch(error => {
    //   // 失败处理，界面提示
    //   alert("录制停止失败: " + error.message);
    // });
  };

  const toggleRecording = () => {
    if (recordingActive) {
      stopRecording();
      return;
    }
    startRecording();
  };

  const pauseRecording = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.pauseRecording,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const resumeRecording = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.resumeRecording,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const startStreaming = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.startStreaming,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const stopStreaming = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.stopStreaming,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const resumeStreaming = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.resumeStreaming,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };
  const hostLeaveMeeting = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.hostLeaveMeeting,
        metadata: "hostLeaveMeeting!!!!!",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
    
  }
  const pauseStreaming = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.pauseStreaming,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const getaudioStatus = () => {
    return participants[0].audio;
    //error
    // const info = storage.get(METTINGPAGE_SAVED_MEETING_INFO)  
    
    // const me = {
    //   audio: true,
      
    // };
    // if(info && !info.muteJoinMeeting){
    //     me.audio = true;
    // } else {
    //   me.audio = false;
    // }
    
  
    // console.log("audio status:" + me.audio);
  
 
    // return me.audio;
  };
  const handleButtonClick = async () => {
    if (isAiLoading) {
      return;
    }
    const command = isAiActive ? Commond.stopAi : Commond.startAi;
    setIsAiLoading(true);
    try {
      const fromPeer = {
        peerid: me.peerId,
        deviceid: 8,
      };
      const aiPayload = {
        command,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer,
        keyTag: "aitextrecord",
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      };
      publish({
        command,
        data: aiPayload,
      }, 'meeting')
      console.log("[aiRecord] publish mqtt", {
        command,
        roomId: conf.roomId,
        conferenceNo: conf.conferenceNo,
        aiPayload,
      });
      const nextActive = command === Commond.startAi;
      setIsAiActive(nextActive);
      ee.emit("aiRecordStatus", nextActive ? "recording" : "completed");
      if (nextActive) {
        ee.emit("openAiRecord");
      }
      message.success(command === Commond.startAi ? '会议纪要已开始' : '会议纪要已停止');
    } catch (error) {
      console.error("[aiRecord] publish failed", error);
      message.error(command === Commond.startAi ? '开始会议纪要失败' : '停止会议纪要失败');
    } finally {
      setIsAiLoading(false);
    }
  };  

  const handleMCUButtonClick = async () => {  
    const action = isMcuActive ? 'stopAction' : 'startAction';
    const actionData =  { 
      action: isMcuActive ? 'stopMcu' : 'startMcu',
      peerId: me.peerId,
      roomId: conf.roomId,
    conferenceNo: conf.conferenceNo, }
    try {
      await service.doCustomActionRequest(action, actionData);
    } catch (error) {
      alert("请求失败: " + (error as Error).message);
    }
    // 更新AI活动状态  
    setIsMcuActive(!isMcuActive);  
  }

  const MediaIconRef = useRef<MicrophoneIconRef>(null);
  
  const audioContextRef = useRef<AudioContext>(null)
  const analyserRef = useRef<AnalyserNode>(null)
  const dataArrayFrequencyRef = useRef<Uint8Array | null>(null) 
  const sourceRef = useRef<MediaStreamAudioSourceNode | null>(null)
  const animationFrameIdRef = useRef<number | null>(null)

  const setupAudioContext = useCallback(() => {
    if (!audioContextRef.current) {
      audioContextRef.current = new AudioContext()
    }
    if (!analyserRef.current) {
      analyserRef.current = audioContextRef.current.createAnalyser()
      analyserRef.current.fftSize = 256 
      analyserRef.current.smoothingTimeConstant = 0.8 

      const gain = audioContextRef.current.createGain()
      gain.gain.value = 0 // Set initial gain value

      const bufferLength = analyserRef.current.frequencyBinCount
      dataArrayFrequencyRef.current = new Uint8Array(bufferLength)
    }
  }, [])

  const drawVolumeBars = useCallback(() => {
    if (!analyserRef.current ) {
      animationFrameIdRef.current = requestAnimationFrame(drawVolumeBars)
      return // Not ready yet
    }

    if (!dataArrayFrequencyRef.current) {
      console.error('Frequency data array is not initialized.')
      return
    }
    analyserRef.current.getByteFrequencyData(dataArrayFrequencyRef.current)

    let sumAmplitude = 0
    for (const amplitude of dataArrayFrequencyRef.current) {
      sumAmplitude += amplitude
    }
    const averageAmplitude
      = sumAmplitude / dataArrayFrequencyRef.current.length
    const normalizedAmplitude = averageAmplitude / 255

    MediaIconRef.current?.drawVolume(normalizedAmplitude * 400)

    animationFrameIdRef.current = requestAnimationFrame(drawVolumeBars)
  }, []) 

  const getMicrophoneInput = useCallback(async () => {
    window.document.removeEventListener('mousemove', FirstCallback)
    console.log('Attempting to access microphone...')
    try {
      if (
        !audioContextRef.current
        || audioContextRef.current.state === 'suspended'
      ) {
        setupAudioContext()
        await audioContextRef.current?.resume()
      }

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })

      // Disconnect previous source if exists
      if (sourceRef.current) {
        sourceRef.current.disconnect()
        sourceRef.current = null
      }

      if (audioContextRef.current) {
        sourceRef.current
          = audioContextRef.current.createMediaStreamSource(stream)
      }
      if (sourceRef.current && analyserRef.current && audioContextRef.current) {
        sourceRef.current.connect(analyserRef.current)
      }

      drawVolumeBars()
      console.log('Microphone input started!')
    }
    catch (err) {
      console.error('Error accessing microphone:', err)
    }
  }, [setupAudioContext, drawVolumeBars])

  const stopMicrophoneInput = useCallback(() => {
    if (sourceRef.current) {
      const tracks = sourceRef.current.mediaStream.getTracks()
      tracks.forEach(track => track.stop()) // Stop all tracks to release microphone
      sourceRef.current.disconnect()
      sourceRef.current = null
    }
    if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
      audioContextRef.current.suspend() // Suspense context for potential reuse
    }
    if (animationFrameIdRef.current) {
      cancelAnimationFrame(animationFrameIdRef.current)
      animationFrameIdRef.current = null
    }
    console.log('Microphone input stopped.')
  }, [])


  const FirstCallback = useCallback(() => {
    if (me.audio) {
      getMicrophoneInput();
    }
  }, [me.audio, getMicrophoneInput]);

  const handleDeviceChanged = useCallback((deviceEvent: any) => {
    switch (deviceEvent.event) {
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_MicAdded:
          console.log(`[App] 新插入的麦克风 id=${deviceEvent.deviceId}, 麦克风状态: ${lastAudioStatus ? '开启' : '关闭'}`);
          message.success('检测到新的麦克风插入');
          if (lastAudioStatus) {
            service.startLocalAudio()
            getMicrophoneInput();
          }
          break;
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_MicRemoved:
          console.log(`[App] 有麦克风被拔出 id=${deviceEvent.deviceId}, 麦克风状态: ${me.audio ? '开启' : '关闭'}`);
          message.warning('检测到麦克风被拔出');
          if (me.audio) {
            service.stopLocalAudio();
            stopMicrophoneInput();
          }
          lastAudioStatus = me.audio;
          break;
        default:
          break;
      }
  }, [me.audio]);

  useEffect(() => {
    window.roomClient?.on('deviceChanged', handleDeviceChanged)
    return () => {
      window.roomClient?.off('deviceChanged', handleDeviceChanged);
    };
  }, [window.roomClient]);

  useEffect(() => {
    window.document.addEventListener('mousemove', FirstCallback)

    setCallback(Commond.allForceMute, async (payload?: MeetingControlPayload) => {
      if (!canHandleControl(payload)) return;
      if (!meRef.current?.audio) return;
      service.stopLocalAudio();
      stopMicrophoneInput();
    })

    setCallback(Commond.allUnMute, async (payload?: MeetingControlPayload) => {
      if (!canHandleControl(payload)) return;
      if (meRef.current?.audio) return;
      service.startLocalAudio()
      await getMicrophoneInput();
    })

    setCallback(Commond.allTurnOnVideo, async (payload?: MeetingControlPayload) => {
      if (!canHandleControl(payload)) return;
      // if (me.video) return;
      service.startLocalPreview()
    })

    setCallback(Commond.allTurnOffVideo, async (payload?: MeetingControlPayload) => {
      if (!canHandleControl(payload)) return;
      // console.log(me.video)
      // if (!me.video) return;
      service.stopLocalPreview()
    })

    setCallback(Commond.singleMute, async (payload?: MeetingControlPayload) => {
      if (!canHandleControl(payload)) return;
      if (payload?.peerId === meRef.current?.peerId) {
        service.stopLocalAudio();
        stopMicrophoneInput();
      }
    })

    setCallback(Commond.singleUnMute, async (payload?: MeetingControlPayload) => {
      if (!canHandleControl(payload)) return;
      if (payload?.peerId === meRef.current?.peerId) {
        service.startLocalAudio()
        await getMicrophoneInput();
      }
    })

    setCallback(Commond.openVideos, async (payload?: MeetingControlPayload) => {
      if (!canHandleControl(payload)) return;
      if (payload?.peerId === meRef.current?.peerId) {
        service.startLocalPreview()
      }
    })

    setCallback(Commond.shieldVideos, async (payload?: MeetingControlPayload) => {
      if (!canHandleControl(payload)) return;
      if (payload?.peerId === meRef.current?.peerId) {
        service.stopLocalPreview()
      }
    })

    setCallback(Commond.removeUser, async (payload?: MeetingControlPayload) => {
      if (!canHandleControl(payload)) return;
      if (payload?.peerId === meRef.current?.peerId) {
        await handleOk()
      }
    })

    return () => {
      window.document.removeEventListener('mousemove', FirstCallback)
      setCallback(Commond.allForceMute, () => undefined)
      setCallback(Commond.allUnMute, () => undefined)
      setCallback(Commond.allTurnOnVideo, () => undefined)
      setCallback(Commond.allTurnOffVideo, () => undefined)
      setCallback(Commond.singleMute, () => undefined)
      setCallback(Commond.singleUnMute, () => undefined)
      setCallback(Commond.openVideos, () => undefined)
      setCallback(Commond.shieldVideos, () => undefined)
      setCallback(Commond.removeUser, () => undefined)
    }
  }, [FirstCallback, canHandleControl, getMicrophoneInput, handleOk, service, setCallback, stopMicrophoneInput])
  return (
    <div className={style.container}>
      <Btn
        // icon={<AudioIcon active={true} />}
        // @ts-ignore
        icon={<MediaIcon ref={MediaIconRef} active={ getaudioStatus()} />}
        // muteJoinMeeting
        onClick={async () => {
          if (me.audio) {
            await service.stopLocalAudio();
            stopMicrophoneInput();
          } else {
            await service.startLocalAudio()
            getMicrophoneInput();
              // let conferenceNo=   conf.conferenceNo
              // //获取会意信息
              // checkPlayTips(conferenceNo).then((res:any)=>{
                 
              //   console.log("conferenceInfo:",res)
              //   if(res.allowSelfUnmute || me.roleCode > 0){
              //     service.startLocalAudio();
              //   }
              // })
            
              
          }
        }}
        // onClick={ service.startLocalAudio  }
        dropdown={micsMenu}
      >
        麦克风
      </Btn>
      {/* <Btn
        icon={<SoundIcon active={speaker} />}
        onClick={speakerClick}
        dropdown={audiosMenu}
        hover={false}
      >
        扬声器
      </Btn> */}
      <Btn
        icon={<VideoIcon active={me.video} />}
        onClick={
          me.video ? service.stopLocalPreview : service.startLocalPreview
        }
        dropdown={videoMenu}
        hover={false}
      >
        摄像头
      </Btn>
      <Btn icon={<SoundIcon active={!soundMute} />} onClick={handleSound} dropdown={testSpeaker()} popover={volumeControl}>
        扬声器
      </Btn>
      <Btn icon={<UserAddOutlined />} onClick={showParticipants}>
        成员
        <small
          style={{
            position: "absolute",
            top: -24,
            right: 0,
            fontWeight: "bold",
          }}
        >
          {displayParticipants.filter((peer) => !peer.share).length}
        </small>
      </Btn>

      {sharingBtn()}

      {loggedIn && userInfo.userId === conferenceInfo?.ownerId && (
        <Btn
          icon={
            <Icon
              type="icon-recording"
              style={recordingActive ? {
                color: '#ff4d4f',
                animation: 'recording-blink 1s infinite'
              } : {}}
            />
          }
          onClick={toggleRecording}
          style={recordingActive ? {
            borderColor: '#ff4d4f',
            boxShadow: '0 2px 8px rgba(255, 77, 79, 0.3)'
          } : {}}
        >
          {recordingActive ? `结束录制` : `开始录制`}
        </Btn>
      )}
      {loggedIn && (
        <Btn
          icon={
            <Icon
              type="icon-recording"
              style={isAiActive ? {
                color: '#1677ff',
                animation: 'recording-blink 1s infinite'
              } : {}}
            />
          }
          onClick={handleButtonClick}
          style={isAiActive ? {
            borderColor: '#1677ff',
            boxShadow: '0 2px 8px rgba(22, 119, 255, 0.3)',
            opacity: isAiLoading ? 0.6 : 1
          } : {
            opacity: isAiLoading ? 0.6 : 1
          }}
        >
          {isAiLoading ? '处理中' : (isAiActive ? '停止纪要' : '开始纪要')}
        </Btn>
      )}
      {/* {me.recording ? (<Btn
        icon={<Icon type="icon-recording" />}
        onClick={me.recordingPaused ? resumeRecording : pauseRecording}
      >
        {me.recordingPaused ? `继续录制` : `暂停录制`}
      </Btn>) : null
      } */}
    
{/* 开始直播 */}
{/*      {loggedIn && (<Btn
        icon={<Icon type="icon-recording" />}
        onClick={me.livestreaming ? stopStreaming : startStreaming}
        dropdown={livestream}
      >
        {me.livestreaming ? `停止直播` : `开始直播`}
      </Btn>)
      } */}

      {/* 启动MCU */}
{/*{loggedIn && (<Btn
        icon={<Icon type="icon-recording" />}
        onClick= {async ()=>{ await handleMCUButtonClick()}}
      >
      {isMcuActive ? '停止MCU' : '启动MCU'}
      </Btn>)
      }*/}

      {/* {me.livestreaming ? (<Btn
        icon={<Icon type="icon-recording" />}
        onClick={me.isLiveStreamingPaused ? resumeStreaming : pauseStreaming}
      >
        {me.isLiveStreamingPaused ? `继续直播` : `暂停直播`}
      </Btn>) : null} */}

      
      <Btn
        icon={<PhoneOutlined className="color-danger" rotate={225} />}
        onClick={leave}
        style={{ float: "right", position: "absolute", right: "0" }}
      >
        离开
      </Btn>
      {showApplyTobeHostButton && (
        <Btn 
        icon={<PhoneOutlined className="color-danger" rotate={125} />}
        style={{ float: "right" }}
        onClick={() => {
          // 在这里处理按钮的点击事件
           setShowApplyTobeHostButton(false);
        }}>
          申请成为主持人
        </Btn>
      )}
      <Modal  visible={isSpining} footer={null}>
        <Spin/>
      </Modal>
      <Modal
        title="共享列表"
        centered
        width={winWidth / 3}
        visible={modelShow}
        onOk={shareCapture}
        onCancel={hideShareModal}
        okText="分享"
        cancelText="取消"
      >
        <Tabs defaultActiveKey="1">
          {sourceList.map((sourceSubs, j) => {
            return (
              <TabPane
                tab={sourceSubs[0]=='screen'?'屏幕':'窗体'}
                key={j}
                style={{ height: winHeight / 3, overflowY: "scroll" }}
              >
                <Row>
                  {sourceSubs[1].map((source: any, key: number) => {
                    return (
                      <Col span={8} key={key}>
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            selSource(e, source);
                          }}
                          style={
                            selectedSource == source
                              ? {
                                  backgroundColor: "black",
                                  borderRight: "3px solid",
                                  marginLeft: "1em",
                                }
                              : { marginLeft: "1em" }
                          }
                        >
                          <Image
                            width={160}
                            height={100}
                            preview={false}
                            src={source.img}
                          />
                          <p style={{ textAlign: "center" }}>{source.name}</p>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </TabPane>
            );
          })}
        </Tabs>
        {/* <video crossOrigin="anonymous" width="500" autoPlay ref={videoRef}></video> */}
      </Modal>

      <Modal
        title="提示"
        visible={isLeaveModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            否
          </Button>,
          <Button key="ok" type="primary" onClick={handleOk}>
            是
          </Button>,
          (userInfo.userId == conf.ownerId) && (<Button key="end" type="ghost" onClick={handleEndMeeting}>
            结束会议
          </Button>),
        ]}
      >
        是否要退出会议？
      </Modal>

      <MicrophoneTest open={isTestMicrophone} onCancel={() => setIsTestMicrophone(false)} devices={inputs} />

      <SpeakerTest open={isTestSpeaker} onCancel={() => setIsTestSpeaker(false)} devices={outputs} />
    </div>
  );
};

export default Footer;
